import React from "react";
import Grid from "@mui/material/Grid";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import User from "./Users";
import { withChatContext } from "context/Chat";
import FilterAutocomplete from "components/FilterAutocomplete";

function Chats({
	errorAllChat,
	chatFilters,
	handleChatFilterChange,
	clearChatFilters,
	chatFilterOptions,
	isChatFilterLoading,
	chatFilterError
}) {
	const statusOptions = (chatFilterOptions?.statuses || []).map((status) => ({ label: status, value: status }));
	const adminOptions = (chatFilterOptions?.admins || []).map((admin) => ({
		label: admin?.name || admin?.email || admin?.label || admin?._id || admin,
		value: admin?._id || admin?.value || admin
	}));
	const userOptions = (chatFilterOptions?.users || []).map((user) => ({
		label: user?.name || user?.email || user?.label || user?._id || user,
		value: user?._id || user?.value || user
	}));
	const propertyOptions = (chatFilterOptions?.properties || []).map((property) => ({
		label: `${property?.Tower || ""} ${property?.FlatNo || ""}`.trim() || property?._id,
		value: property?._id || property?.value || property
	}));
	const complainOptions = (chatFilterOptions?.complains || []).map((complain) => ({
		label: complain?.title || complain?.Number || complain?.label || complain?._id || complain,
		value: complain?._id || complain?.value || complain
	}));

	return (
		<div style={{ height: "80vh", overflow: "auto", position: "relative", padding: "20px 0px" }}>
			<div
				style={{
					width: "98%",
					position: "sticky",
					top: "1%",
					padding: "16px 20px",
					background: "#FFF",
					borderRadius: "10px",
					zIndex: 1000,
					boxShadow: "0 4px 12px rgba(0,0,0,0.08)"
				}}
			>
				<Grid container spacing={1}>
					<Grid item xs={12} sm={6}>
						<FilterAutocomplete
							name="status"
							label="Status"
							value={chatFilters.status}
							options={statusOptions}
							onChange={handleChatFilterChange}
							loading={isChatFilterLoading}
							disabled={isChatFilterLoading}
							placeholder="Search status"
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<FilterAutocomplete
							name="admin"
							label="Admin"
							value={chatFilters.admin}
							options={adminOptions}
							onChange={handleChatFilterChange}
							loading={isChatFilterLoading}
							disabled={isChatFilterLoading}
							placeholder="Search admin"
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<FilterAutocomplete
							name="user"
							label="User"
							value={chatFilters.user}
							options={userOptions}
							onChange={handleChatFilterChange}
							loading={isChatFilterLoading}
							disabled={isChatFilterLoading}
							placeholder="Search user"
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<FilterAutocomplete
							name="property"
							label="Property"
							value={chatFilters.property}
							options={propertyOptions}
							onChange={handleChatFilterChange}
							loading={isChatFilterLoading}
							disabled={isChatFilterLoading}
							placeholder="Search property"
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<FilterAutocomplete
							name="complain"
							label="Complain"
							value={chatFilters.complain}
							options={complainOptions}
							onChange={handleChatFilterChange}
							loading={isChatFilterLoading}
							disabled={isChatFilterLoading}
							placeholder="Search complain"
						/>
					</Grid>
					<Grid item xs={12} display="flex" justifyContent="flex-end">
						<MDButton
							variant="outlined"
							color="info"
							size="small"
							disabled={isChatFilterLoading}
							onClick={clearChatFilters}
						>
							Clear filters
						</MDButton>
					</Grid>
				</Grid>
				{chatFilterError && (
					<MDTypography variant="caption" color="error">
						{chatFilterError}
					</MDTypography>
				)}
			</div>
			{errorAllChat ? (
				<MDTypography variant="h4" mt={2}>
					Sorry There Was Some Error
				</MDTypography>
			) : (
				<User />
			)}
		</div>
	);
}

export default withChatContext(Chats);
